import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Alert, Tooltip, Card} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import moment from 'moment';

import {Order} from '../../interfaces';
import {GET_ORDERS} from '../../graphql';
import {getIntoObject} from '../../helpers';

import ListOrders from './components/ListOrders';

interface Properties {
  regionId: string;
}

class OrdersHistory extends Component<Properties> {
  render() {
    const {regionId} = this.props;
    return (
      <Query query={GET_ORDERS} variables={{regionId, first: 10}} notifyOnNetworkStatusChange>
        {({loading, refetch, error, data: {order : person, clubs}}: any) => {
          
          if (error) {
            return `Error! ${error.message}`;
          }
          const columns: Array<ColumnProps<Order>> = [
            {
              title: 'Date',
              key: 'date',
              render: (order: Order) => {
                const date: Date = Number(order.createdAt) ? new Date(Number(order.createdAt)) : new Date(order.createdAt);

                return (
                  <Tooltip title={moment(date).format('HH:mm')}>
                    <span>{moment(date).format('YYYY-MM-DD')}</span>
                  </Tooltip>
                );
              },
            },

            {
              title: 'Email',
              key: 'email',
              render: ({order}: Order) => getIntoObject(order, ['person', 'email'], '-'),
            },
            {
              title: 'Person name',
              key: 'person_name',
              render: ({order}: Order) => getIntoObject(order, ['person', 'name'], '-'),
            },

          ];
          return (
            <ListOrders
              columns={columns}
              orderData={person ? person.order : []}
              totalPages={person ? person.totalCount : 0}
              refetch={refetch}
              regionId={regionId}
              loading={loading}
              clubs={clubs || []}
            />
          );
        }}
      </Query>
    );
  }
}

export default OrdersHistory;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/ListOrdersWrap.tsx